import { useState, useEffect } from 'react';

import GroupSendCoupon from '@/layouts/baseHeader/components/GroupSendCoupon';
import Modal from '@/layouts/baseHeader/components/Modal';
import NewCustomerPop from '@/layouts/baseHeader/components/NewCustomerPop';
import PopAd from '@/layouts/baseHeader/components/PopAd';
import RedEnvelopeRainPop from '@/layouts/baseHeader/components/RedEnvelopeRainPop'; // 红包雨
import indexBuriedPoint, { indexBuriedPointPopMap } from '@/utils/_indexBuriedPoint';
import Domains from '@/utils/domains';
import sendAxios from '@/utils/request';
import Utils from '@/utils/Utils';

const IndexDialogManage = ({ grey }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [logined, setLogined] = useState(false);
  const [openType, setOpenType] = useState(null);
  const [popAdData, setPopAdData] = useState(0); // 广告弹窗
  const [newCustomerDatas, setNewCustomerDatas] = useState(0); // 新人福利弹窗
  const [groupSendCoupons, setGroupSendCoupons] = useState(0); // 分群福利弹窗
  const [redEnvelopeData, setRedEnvelopeData] = useState(0); // 红包雨

  function popList() {
    // 弹窗流程,没登陆则不弹任何弹窗
    setLogined(true);
    fetchPopInfo();
    return;
  }

  useEffect(() => {
    window.popList = popList;
    // 方法挂载完毕后，触发自定义事件通知其他组件
    const event = new CustomEvent('popListMethodReady');
    document.dispatchEvent(event);

    // // 清理方法
    // return () => {
    //   delete window.popList;
    // };
  }, []);

  function fetchPopInfo() {
    const fnMap = {
      newcustomer: setNewCustomerDatas, // 新人
      group: setGroupSendCoupons, // 分群
      alert: setPopAdData, // 营销广告
      redpacket: setRedEnvelopeData, // 红包雨
    };
    sendAxios({
      method: 'get',
      url: '/market/alert/new',
      baseURL: Domains.lcscActivityUrl,
      params: {
        ru: new URLSearchParams(window.location.search).get('ru') || '',
        alertPage: 'www',
      },
    }).then((res) => {
      if (res.code === 200 && res.msg && res.result) {
        fnMap[res.msg] && fnMap[res.msg](res.result);
      }
    });
  }

  const toggleModal = () => {
    indexBuriedPoint(indexBuriedPointPopMap[openType] || '未定义OP', '', 'click', 'close');
    setIsOpen(false);
    setOpenType(null);
  };

  useEffect(() => {
    function setN() {
      setOpenType('new-user-pop');
    }
    function setG() {
      setOpenType('group-user-pop');
    }
    function setAd() {
      setOpenType('ad-pop');
    }
    function setRedpacketRain() {
      setOpenType('redpacket-rain');
    }
    if (logined) {
      if (popAdData !== 0 && !Utils.isEmpty(popAdData)) {
        // 营销广告有数据
        setIsOpen(true);
        setAd();
      }
      if (groupSendCoupons !== 0 && groupSendCoupons?.isPopup) {
        // 分群弹窗有数据
        setIsOpen(true);
        setG();
      }
      if (newCustomerDatas !== 0 && !Utils.isEmpty(newCustomerDatas)) {
        // 新人送券有数据
        setIsOpen(true);
        setN();
      }
      if (redEnvelopeData !== 0) {
        // 下红包雨
        setIsOpen(true);
        setRedpacketRain();
        if (redEnvelopeData?.theme === 'blue') {
          // 显示底部渐变背景色
          setTimeout(() => {
            const dom = document.querySelector('#fixed-bottom-bg');
            dom.style.display = 'block';
          }, 0);
        }
      }
    }
  }, [popAdData, newCustomerDatas, groupSendCoupons, redEnvelopeData, logined]);

  return (
    <>
      {openType === 'redpacket-rain' && (
        <Modal
          openType={openType}
          open={isOpen}
          onClose={toggleModal}
          className={`bg-transparent ${grey ? 'grey-filter' : ''}`}
        >
          <RedEnvelopeRainPop
            theme={redEnvelopeData.theme}
            isYuanXiao={redEnvelopeData.isYuanXiao} // 是否元宵节活动
            uuid={redEnvelopeData.uuid || ''}
            onClose={toggleModal}
          />
        </Modal>
      )}
      {openType === 'group-user-pop' && (
        <Modal open={isOpen} onClose={toggleModal} className={`bg-transparent ${grey ? 'grey-filter' : ''}`}>
          <GroupSendCoupon
            data={groupSendCoupons}
            targetLink={Domains.lcscMemberUrl + '/member/couponList.html'}
          ></GroupSendCoupon>
        </Modal>
      )}
      {openType === 'ad-pop' && (
        <Modal open={isOpen} onClose={toggleModal} className={`bg-transparent ${grey ? 'grey-filter' : ''}`}>
          <PopAd data={popAdData}></PopAd>
        </Modal>
      )}
      {openType === 'new-user-pop' && (
        <Modal
          open={isOpen}
          onClose={toggleModal}
          className={`w-[557px] h-[682px] bg-transparent ${grey ? 'grey-filter' : ''}`}
        >
          <NewCustomerPop
            data={newCustomerDatas}
            targetLink={Domains.lcscActivityUrl + '/newuser.html'}
          ></NewCustomerPop>
        </Modal>
      )}
    </>
  );
};

export default IndexDialogManage;
